import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';

@Component({
  selector: 'app-session-timer-end-warning-dialog',
  templateUrl: './session-timer-end-warning-dialog.component.html',
  styleUrls: ['./session-timer-end-warning-dialog.component.css']
})
export class SessionTimerEndWarningDialogComponent implements OnInit {

  continueTimer: boolean;

  constructor(
    public dialogRef: MatDialogRef<SessionTimerEndWarningDialogComponent>,
    private ref: ElementRef,
    public shopSettingsService: ShopSettingsService,
    private renderer: Renderer2,
  ) {
  }

  ngOnInit(): void {
    if (this.shopSettingsService.isVUMode) {
      this.renderer.addClass(this.ref.nativeElement, 'vu-mode');
    }
  }

  closeClick(): void {
    this.continueTimer = true;
    this.dialogRef.close();
  }
}
